<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <ik-data-table
    ref="table"
    :icon="'mdi-format-list-bulleted'"
    :model="model"
    :use-delete-action="false"
    :use-select="true"
    entity-name="FreeInformationBon"
  >
    <template #item.operation="{item}">
      <v-btn
        :disabled="item.id.toString() === '-9' || item.id.toString() === '-10'"
        :height="!$vuetify.breakpoint.lgAndUp ? '40px' : ''"
        :icon="!$vuetify.breakpoint.lgAndUp"
        :style="!$vuetify.breakpoint.lgAndUp ? 'border-radius: 12px; background: #f57c00;' : ''"
        :width="!$vuetify.breakpoint.lgAndUp ? '40px' : ''"
        color="amber lighten-4 black--text"
        elevation="0"
        small
        @click.stop="deleteFreeInfoSheet(item)"
      >
        <template v-if="!$vuetify.breakpoint.lgAndUp">
          <v-icon color="white">
            mdi-cog
          </v-icon>
        </template>
        <template v-if="$vuetify.breakpoint.lgAndUp">
          <div
            :class="!$vuetify.breakpoint.lgAndUp ? 'text-truncate' : ''"
            :style="!$vuetify.breakpoint.lgAndUp ? 'max-width: 100px;' : ''"
          >
            {{ $t('delete') }}
          </div>
        </template>
      </v-btn>
    </template>
  </ik-data-table>
</template>

<script>
import FreeInfoSheet from '@/model/dataLayer/api/print/FreeInfoSheet'
import IkDataTable from '@/plugins/EntityFrameWork/IkDataTable.vue'

export default {
  name: 'FreeInfoSheetVue',
  components: { IkDataTable },
  data () {
    return {
      model: FreeInfoSheet
    }
  },
  methods: {
    async deleteFreeInfoSheet (item) {
      await FreeInfoSheet.remove(item.id)
      await this.$refs.table.reload()
    }
  }
}
</script>

<style scoped>

</style>
